import { useEffect } from 'react'
import { Box } from '@chakra-ui/react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { GenerateImageStep } from './Steps'

export function NovaArte() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const taskId = searchParams.get('task_id')

  // Redirecionar para a página de seleção de imagem se houver um taskId
  useEffect(() => {
    if (taskId) {
      navigate(`/pattern/generate-images/${taskId}`)
    }
  }, [taskId, navigate])

  // Renderiza apenas o GenerateImageStep - outros steps serão renderizados em rotas separadas
  return (
    <Box pb="100px">
      <GenerateImageStep />
    </Box>
  )
}
